import React from "react";
import BaseComponent from "../BaseComponent.js";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";
import { elementMatchesAny } from "../Global/tools.js";

import NanoFlex from "../Global/NanoFlex";
import Type from "../Global/Typography.js";
import Image from "../Nano/Image.js";
import PerformanceColor from "../Nano/PerformanceColor.js";

import { ReactComponent as Check } from "../Global/Icons/check.svg";
import { ReactComponent as PerformanceIndicatorCorner } from "../Global/Icons/PerformanceIndicatorCorner.svg";
import { ReactComponent as ArrowDown } from "../Global/Icons/arrowDown.svg";

const multiple = nota.global.multiple;

const StyledBlank = styled(NanoFlex)`
  width: 100%;
  height: ${(props) => props.height + "px"};
`;

const StyledTableListLine = styled.div`
  margin-bottom: ${multiple / 2 + "px"};
  cursor: pointer;
  /* padding-right: 4px; */
  width: 100%;
  .lineWrapper {
    display: grid;
    /* grid-template-columns: 200px calc(100% - 200px); */
    grid-template-columns: 230px calc(100% - 230px);
    padding: 0px 4px 0px 0;
    .lineColumnWrapper {
      .imgThumbContainer {
        div {
          /* .imgWrapper,
          .loader,
          .svgWrapper {
            height: 100%;
          } */
        }
      }
    }
    .lineItem {
      height: auto;

      p {
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      .doubleLine {
        p {
          color: ${nota.color.secondary.aquaGreen};
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .highlightInfo {
          color: ${nota.color.secondary.aquaGreen};
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
        .fomartTitle {
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
      }

      .dateStyle {
        background-color: ${nota.color.main.default};
        padding: 4px 0px;
        color: ${nota.color.neutral.white};
        width: 100%;
        text-align: center;
      }

      .colorText {
        color: ${nota.color.main.default};
      }

      .performanceWrapper {
        background-color: ${nota.color.neutral.NeuFive};
        padding: 4px 0px;
        position: relative;
        svg {
          position: absolute;
          right: 0;
          bottom: -2px;
          width: 14px;
        }
      }

      &:last-child {
        margin-right: 0;
      }
    }
    .backgroundItemSec {
      background-color: ${nota.color.neutral.NeuFive};
      height: auto;
      padding: 4px 0px;
      p {
        color: ${nota.color.secondary.aquaGreen};
      }
    }

    .infoLineWrapper {
      /* height: 72px; */
      height: auto;
      padding: 8px 0;
    }

    .xxs {
      flex: 0;
      min-width: 35px;
      margin-right: 0;
    }
    .xs {
      flex: 2;
    }
    .s {
      flex: 3;
    }
    .m {
      flex: 4;
    }
    .l {
      flex: 6;
    }
  }

  .collapsedInfo {
    display: none;
  }
  .openedInfo {
    display: flex;
    justify-content: flex-start;
    p {
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }

  &:nth-child(even) {
    background: rgba(245, 245, 245, 0.6);
  }

  &:hover {
    background: rgba(245, 245, 245, 0.4);
  }

  .checkItem {
    .checkLineWrapper {
      height: 100%;
      width: 100%;
      cursor: pointer;
      background-color: ${nota.color.neutral.NeuFour};
      svg {
        width: 10px;
        path {
          fill: ${nota.color.neutral.NeuTwo};
        }
      }
      &:hover {
        opacity: 0.5;
      }
    }

    .selectedLine {
      background-color: ${nota.color.main.default};
      svg {
        path {
          fill: ${nota.color.neutral.white};
        }
      }
    }
  }

  .lineItemsContainer {
    min-width: 0;
    padding-left: 8px;
    .lineItem {
      margin-right: 8px;
      min-width: 0;
      p {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: pre-wrap;
      }
    }
    .highlightItem {
      /* background-color: ${nota.color.secondary.aquaGreen}; */
      padding: 4px 0px;
      height: auto;
      p {
        /* color: ${nota.color.secondary.aquaGreen}; */
        text-transform: uppercase;
      }
    }
  }
`;
const excludedLineClick = [".checkItem", ".collapseBtnWrapper"];

class TableSearchListLine extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      isVisible: true,
      isSelected: this.props.isSelected ? this.props.isSelected : false,
      additionalInfoOpen: this.props.additionalInfoOpen !== null && this.props.additionalInfoOpen !== undefined ? this.props.additionalInfoOpen : true,
    };
    this.container = React.createRef();

    this.containerHeight = 0;
    this.preventOnSelectedChange = false;
  }

  componentDidMount() {
    super.componentDidMount();

    const lazyLoad = (target) => {
      const io = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting !== this.state.isVisible) {
              if (!entry.isIntersecting) {
                this.containerHeight = entry.boundingClientRect.height;
              }
              this.setState({ isVisible: entry.isIntersecting });
            }
          });
        },
        { rootMargin: "100px" }
      );

      io.observe(target);
    };

    lazyLoad(this.container.current);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.isSelected !== prevProps.isSelected) {
      this.preventOnSelectedChange = true;
      this.setState({ isSelected: this.props.isSelected ? this.props.isSelected : false }, () => {
        this.preventOnSelectedChange = false;
      });
    }

    if (this.state.isSelected !== prevState.isSelected && this.props.onSelectedChange && !this.preventOnSelectedChange) {
      this.props.onSelectedChange(this.props.data.idProgram);
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  additionalInfoClick = () => {
    this.setState({ additionalInfoOpen: !this.state.additionalInfoOpen });
  };

  onLineClick = (e) => {
    /*Exclude elements from click */
    if (elementMatchesAny(e.target, excludedLineClick)) return;

    window.open(`/card/${this.props.data.idProgram}`, "_blank");
  };

  onCheckClick = () => {
    this.setState({ isSelected: !this.state.isSelected });
  };

  render() {
    if (!this.props.data) return null;

    return (
      <StyledTableListLine ref={this.container} key={this.props.data.idProgram}>
        {this.state.isVisible && (
          <NanoFlex className={`lineWrapper ${this.props.advancedSearchVisible ? "advancedSearchVisible" : ""}`} onClick={this.onLineClick}>
            <NanoFlex className="lineColumnWrapper">
              {/* CHECK */}
              <NanoFlex className="checkItem xxs" justifyContent="center" alignContent="center" alignItems="center">
                <NanoFlex className={`checkLineWrapper ${this.state.isSelected ? "selectedLine" : ""}`} onClick={this.onCheckClick}>
                  <Check />
                </NanoFlex>
              </NanoFlex>
              {/* IMAGE */}
              <NanoFlex className="imgThumbContainer">
                <Image imageUrl={this.props.data.image} alt={this.props.data.image} isNotaSelection={this.props.data.isNotaSelection} isNew={this.props.data.isNew} />
              </NanoFlex>
            </NanoFlex>

            <NanoFlex className="lineItemsContainer" flexDirection="column" alignContent="flex-start">
              <NanoFlex className="infoLineWrapper" justifyContent="flex-start" alignItems="flex-start">
                <NanoFlex className="lineItem s highlightItem" justifyContent="flex-start">
                  <Type.p title={this.props.data.country}>
                    <b>{this.props.data.country}</b>
                  </Type.p>
                </NanoFlex>
                <NanoFlex className="lineItem s highlightItem" justifyContent="flex-start">
                  <Type.p title={this.props.data.channel}>
                    <b>{this.props.data.channel}</b>
                  </Type.p>
                </NanoFlex>
                <NanoFlex className="lineItem s" flexDirection="column" justifyContent="flex-start">
                  <Type.p className="dateStyle" title={this.props.data.date}>
                    <b>{this.props.data.date}</b>
                  </Type.p>
                  <Type.p className="colorText" title={this.props.data.beginTime}>
                    {this.props.data.beginTime}
                  </Type.p>
                </NanoFlex>
                <NanoFlex className="lineItem l" justifyContent="flex-start">
                  <NanoFlex className="doubleLine" flexDirection="column" alignItems="flex-start">
                    <Type.p className="highlightInfo" title={this.props.data.localTitle}>
                      <b>{this.props.data.localTitle}</b>
                    </Type.p>
                    {this.props.data.localTitle !== this.props.data.formatTitle && (
                      <Type.p className="fomartTitle" title={this.props.data.formatTitle}>
                        {this.props.data.formatTitle}
                      </Type.p>
                    )}
                  </NanoFlex>
                </NanoFlex>
                <NanoFlex className="lineItem m" justifyContent="flex-start">
                  <Type.p className="colorText" title={this.props.data.subGenre}>
                    {this.props.data.subGenre}
                  </Type.p>
                </NanoFlex>
                <NanoFlex className={`lineItem s ${this.props.data.formatType ? "backgroundItemSec" : ""}`}>
                  <Type.p title={this.translation.geral.formatTypes[this.props.data.formatType?.toLowerCase()]}>
                    <b>{this.translation.geral.formatTypes[this.props.data.formatType?.toLowerCase()]}</b>
                  </Type.p>
                </NanoFlex>

                {!this.props.hideRatings && (
                  <NanoFlex className="lineItem xs">
                    <NanoFlex className="performanceWrapper" title={this.translation.components.tableSearchListLine.performanceColorTooltip}>
                      <Type.p title={this.props.data.shrPremiere !== null ? `${this.props.data.shrPremiere} %` : "-"}>{this.props.data.shrPremiere !== null ? `${this.props.data.shrPremiere} %` : "-"}</Type.p>
                      <PerformanceColor color={this.props.data.premiereColor} />
                    </NanoFlex>
                  </NanoFlex>
                )}
                {!this.props.hideRatings && (
                  <NanoFlex className="lineItem xs">
                    <NanoFlex className="performanceWrapper" title={this.translation.components.tableSearchListLine.performanceColorTooltip}>
                      <Type.p title={this.props.data.shrAverage !== null ? `${this.props.data.shrAverage} %` : "-"}>{this.props.data.shrAverage !== null ? `${this.props.data.shrAverage} %` : "-"}</Type.p>

                      <PerformanceColor color={this.props.data.averageColor} />
                    </NanoFlex>
                  </NanoFlex>
                )}
              </NanoFlex>

              <NanoFlex className={`collapsedInfo ${this.state.additionalInfoOpen ? "openedInfo" : ""}`} title={this.props.data.concept}>
                <Type.p justify>{this.props.data.concept}</Type.p>
              </NanoFlex>
            </NanoFlex>
          </NanoFlex>
        )}
        {!this.state.isVisible && <StyledBlank height={this.containerHeight} />}
      </StyledTableListLine>
    );
  }
}

export default TableSearchListLine;

// --- // Documentation // --- //
/*
  import TableSearchListLine from './../Micro/TableSearchListLine.js';
  
  <TableSearchListLine data={} />
  */
